module.exports = __webpack_public_path__ + "static/img/wq.88d408b6.svg";